/* external */
import React, { useCallback, useMemo } from "react";

/* internal */
import StandardsSelectionModal from "AppComponents/StandardsSelectionModal";
import { STANDARD_UIDS } from "modules/Services/ServicesConstants";
import { parseInitialSelectedStandards } from "AppComponents/AssessmentLearningGoals/module/AssessmentLearningGoalsUtils";

/* relative */

const AssessmentSubjectStandards = ({
  onClose,
  updateInputField,
  selectedLearningGoalKey,
  learningCourseId,
  hasAddRemoveValues,
  curriculumType,
  assessmentId,
  assessmentFields,
}) => {
  const standardUID = STANDARD_UIDS[curriculumType] || selectedLearningGoalKey;

  const initialSelectedStandards = useMemo(
    () =>
      parseInitialSelectedStandards({
        assessmentFields,
        curriculumType,
        standardUID,
      }),
    [assessmentFields, curriculumType, standardUID]
  );

  const handleSelectClick = useCallback(
    async ({ selectedStandards, nodes }) => {
      // Flatten the per-set objects to the flat shapes expected downstream.
      const flatIds = Object.values(selectedStandards).flat();
      const flatNodes = Object.values(nodes).flat();

      updateInputField(
        { [standardUID]: flatIds },
        { nodes: flatNodes },
        true,
        hasAddRemoveValues
      );
      onClose();
    },
    [standardUID, updateInputField, hasAddRemoveValues, onClose]
  );

  return (
    <StandardsSelectionModal
      mode={"create"}
      onClose={onClose}
      onSelectClick={handleSelectClick}
      learningCourseId={learningCourseId}
      initialSelectedStandards={initialSelectedStandards}
      canMapGradeScale={false}
      shouldSyncStandards={false}
      assessmentId={assessmentId}
      allowMultiSetSelection={true}
    />
  );
};

export default AssessmentSubjectStandards;
